#@import GliveBooking.Views.Quantity
#@export GliveBooking.Views.Quantities

class GliveBooking.Views.Quantities extends BookingV2.Views.PartySizes

  module: 'glive-booking'

  templateName: 'quantities'

  childView: GliveBooking.Views.Quantity
